/**
 * save-aggregation-schema-request.ts
 * Copyright (c) 2016-2017, My Coverage Plan, Inc.
 * All rights reserved.
 */

/**
 * @author Taylor DH Smith <tdsmith@safetyweb.org>
 */

import { Message } from "../general/message";
import { ReplyVerifyingMessage } from "../general/reply-message";
import { MessageTag } from "../message-tag";

export class SaveAggregrationSchemaRequest extends ReplyVerifyingMessage
{
  /** The unique tag for this message type */
  public tag : MessageTag = MessageTag.REQ_SAVE_AGGREGATION_SCHEMA;
	public static tag : MessageTag = MessageTag.REQ_SAVE_AGGREGATION_SCHEMA;

  public verifyReply (reply : Message) : boolean
  {
    return Message.isA(reply, MessageTag.RSP_SAVE_REPORT_SCHEMA);
  }

  constructor (
    public aggregationId : number,
    public schemaName : string,
    public isGroupPublic : boolean = false
  )
  {
    super();
  }

}



// WEBPACK FOOTER //
// ./~/angular-router-loader/src!./app/server/messages/schemas/save-aggregation-schema-request.ts